import React from 'react';
import PropTypes from 'prop-types';
import FJUtil from '../../../util/FJUtil';
import FJLocalStore from '../../../store/FJLocalStore';
import { MODEL_VALUE_MAP } from '../../../config/dataConfig/FJAIVideoGeneratorData';
import styles from './FJSourceErrorDisplay.module.less';
import useLocalStore from '../../../hooks/useLocalStore';

const FJSourceErrorDisplay = ({
    data,
    isVideoEffect,
    useVideoSimpleErrorText = true,
    linkUrl = 'https://help.flexclip.com/en/articles/13229410-why-your-content-may-be-flagged-as-sensitive',
}) => {
    useLocalStore();
    const isVideoGenerator = FJUtil.isVideoGenerator();
    const errorCode = data?.errorCode;

    const errorText = () => {
        if (isVideoGenerator && useVideoSimpleErrorText) {
            const isIllegal = data?.errorCode && data?.errorCode === 423;
            let message = isVideoEffect
                ? 'generation-failed-please-try-again-or-try-other-images'
                : isIllegal
                  ? 'generation-failed-due-to-potential-content-violations-please-click-retry'
                  : 'failed-to-generate-video-please-click-retry';
            if (String(errorCode) === '424') {
                message = 'no-people-actions-detected-upload-a-new-video-to-retry';
            }
            if (String(errorCode) === '425') {
                message = 'no-people-actions-detected-upload-a-new-image-to-retry';
            }
            return FJLocalStore._(message);
        }

        if (String(errorCode) === '423') {
            const model = data?.model;
            //  model 是模型的名字
            const isSora2Model = model === 'OpenAI Sora 2' || model === 'OpenAI Sora 2 Pro';
            const textKey = isSora2Model ? 'sensitive-content-error-sora' : 'sensitive-content-error';
            const text = FJLocalStore._(textKey);
            const match = text.match(/(.*)<a>(.*)<\/a>(.*)/);
            if (match) {
                return (
                    <>
                        {match[1]}
                        <span
                            className={styles.link_span}
                            onClick={() => {
                                window.open(linkUrl, '_blank');
                            }}
                        >
                            {match[2]}
                        </span>
                        {match[3]}
                    </>
                );
            }

            return text;
        }

        if (String(errorCode) === '501') {
            return FJLocalStore._('error-501');
        }

        return null;
    };

    if (!errorText && !errorCode) return null;

    return <div className={styles.error_text}>{errorText()}</div>;
};

FJSourceErrorDisplay.propTypes = {
    data: PropTypes.object,
    isVideoEffect: PropTypes.bool,
    linkUrl: PropTypes.string,
};

export default FJSourceErrorDisplay;
